import { Collapse, Form } from 'antd';
import { useState } from 'react';
import FormField from './FormField';
import { authTypeField, usernameField, passwordField, bearerTokenField } from './fieldConfigs';

const { Panel } = Collapse;

interface AuthenticationSectionProps {
    collapsible?: boolean;
    showOAuth?: boolean;
}

export default function AuthenticationSection({ collapsible = true, showOAuth = false }: AuthenticationSectionProps) {
    const form = Form.useFormInstance();
    const initialAuthType = (form.getFieldValue(['configuration', 'authType']) as string) || 'none';
    const [authType, setAuthType] = useState<string>(initialAuthType);

    const handleAuthTypeChange = (value: unknown) => {
        setAuthType(value as string);
    };

    const content = (
        <>
            <FormField config={authTypeField(handleAuthTypeChange)} />

            {authType === 'basic' && (
                <>
                    <FormField config={usernameField} />
                    <FormField config={passwordField} />
                </>
            )}

            {authType === 'bearer' && <FormField config={bearerTokenField} />}

            {showOAuth && authType === 'oauth2' && (
                <FormField
                    config={{
                        name: 'token',
                        label: 'Access Token',
                        type: 'password',
                        required: true,
                        placeholder: 'OAuth access token',
                    }}
                />
            )}
        </>
    );

    if (!collapsible) {
        return <>{content}</>;
    }

    return (
        <Collapse
            className="!mb-5 bg-gray-50"
            defaultActiveKey={['auth']}
        >
            <Panel
                header="Authentication"
                key="auth"
            >
                {content}
            </Panel>
        </Collapse>
    );
}
